<sux-section [isGrey]="true">
  <h3 class="mb-10">{{ 'kontoverbindungen.title' | translate }}</h3>

  <ng-container *ngIf="kontoverbindungen$ | async as kontoverbindungen">
    <kvb-kontoverbindung-view
      *ngIf="kontoverbindungen && kontoverbindungen.length > 0 && !isInEditMode"
      [kontoverbindungen]="kontoverbindungen"
      (kontoverbindungSelectedForEditing)="onEditClick($event)"
    >
    </kvb-kontoverbindung-view>

    <ng-container *ngIf="kontoverbindungen?.length === 0 && !isInEditMode">
      <sux-message title="{{ 'kontoverbindungen.new.title' | translate }}" type="info">
        <p>
          {{ 'kontoverbindungen.new.intro' | translate }}
        </p>
        <sux-button (click)="onNewClick()" layout="secondary">{{
          'kontoverbindungen.new.button' | translate
        }}</sux-button>
      </sux-message>
    </ng-container>

    <ng-container *ngIf="isInEditMode">
      <kvb-kontoverbindung-edit
        [kontoverbindung]="kontoverbindungForEditing!"
        (kontoverbindungSaved)="onKontoverbindungSaved()"
      ></kvb-kontoverbindung-edit>
    </ng-container>
  </ng-container>
  <sux-exception [exceptions]="exceptions"></sux-exception>
</sux-section>
